import { Routes } from '@angular/router';
import { content } from './shared/routes/content.routes';
import { authen } from './shared/routes/auth.routes';
import { landing } from './shared/routes/landing.routes';
import { EcommerceLayoutComponent } from './shared/layouts/ecommerce-layout/ecommerce-layout.component';
import { customer } from './shared/routes/ecommerce.routes';
import { ClassifiedLayoutComponent } from './shared/layouts/classified-layout/classified-layout.component';
import { AuthenticationLayoutComponent } from './shared/layouts/authentication-layout/authentication-layout.component';
import { ContentLayoutComponent } from './shared/layouts/content-layout/content-layout.component';

export const App_Route: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '', component: ContentLayoutComponent, children: content },
  { path: '', component: AuthenticationLayoutComponent, children: authen },
  { path: '**', redirectTo: '/error/error404', pathMatch: 'full' },
];
